var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable tailwindcss/no-arbitrary-value */
import { Radio, RadioGroup, SelectionControlLabel, Typography, } from '@one-thd/sui-atomic-components';
import { Checkmark, ErrorFilled } from '@one-thd/sui-icons';
import React from 'react';
import { integrationLinkErrorMessageHelper, integrationMessageHelper, } from '../../../../utils/buildertrend-utils';
import { getWindow } from '../../../../utils/general';
import '../../../../styles/buildertrend.scss';
/**
 * Buildertrend Body element and components for connecting Buildertrend Account
 */
var builderTrendSync = function () { return (React.createElement("div", { className: "sui-flex sui-items-center buildertrend__logo svg", style: { width: '33%' } },
    React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/BuildertrendFull.svg", alt: "Buildertrend Icon", width: "210px", height: "44px" }))); };
var renderSyncingLine = function () { return (React.createElement("div", { className: "quickbooks-sync-progress__wavy-loader", style: { width: '33%' } }, [1, 2, 3, 4, 5].map(function (id) { return (React.createElement("span", { key: id })); }))); };
var homeDepotSync = function () { return (React.createElement("div", { className: "sui-flex sui-justify-end buildertrend-homedepot__logo svg", style: { width: '28%', marginTop: '25px', marginBottom: '25px' } },
    React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/HomeDepotLogo.svg", alt: "Home Depot Logo", width: "150px", height: "150px" }))); };
var builderTrendAuthorizeShare = function () {
    return (React.createElement("div", { className: "sui-flex sui-justify-between sui-border-b-2 sui-border-solid sui-border-b-strong" },
        homeDepotSync(),
        renderSyncingLine(),
        builderTrendSync()));
};
var firstInfoList = function () { return (React.createElement("ul", { className: "sui-list-disc sui-pb-2", style: { padding: '5px 5px 5px 20px' } },
    React.createElement("li", null, "Sync your Pro Xtra purchase history and products on your Pro Xtra My List page with Buildertrend"),
    React.createElement("li", null, "Easily build proposals for your customers using products from The Home Depot when using Buildertrend\u2019s software"),
    React.createElement("li", null, "Add products to your cart on homedepot.com directly from your Buildertrend account"),
    React.createElement("li", null, "Get a 1% discount on products purchased in-store and online from The Home Depot*"))); };
var builderTrendTermsAndConditions = function () {
    return (React.createElement("button", { type: "button", className: "sui-pb-1 sui-underline", onClick: function () {
            var _a;
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.open('https://buildertrend.com/terms-and-conditions/');
        } }, "Terms and Conditions Agreement"));
};
var builderTrendPrivacyStatementLink = function () {
    return (React.createElement("button", { type: "button", className: "sui-pb-1 sui-underline", onClick: function () {
            var _a;
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.open('https://buildertrend.com/company/privacy-policy/');
        } }, "Privacy Policy"));
};
var secondInfoList = function () { return (React.createElement("ul", { className: "sui-list-disc sui-pb-2", style: { padding: '5px 5px 5px 20px' } },
    React.createElement("li", null, "Your Pro Xtra customer number and company name;"),
    React.createElement("li", null, "The SKU number, image and price for products stored on the My List page; and"),
    React.createElement("li", null, "Your Pro Xtra purchase history (for the prior 25 months), including SKU numbers, quantities, purchase price, date, order number, job name, and store number."))); };
var buildertrendInfo = function () {
    return (React.createElement("div", { className: "sui-pt-8 sui-border-t-2 sui-border-w-" },
        React.createElement("div", { className: "sui-pb-1" },
            React.createElement(Typography, { variant: "body-base" }, "We are excited to offer Pro Xtra members who use Buildertrend's software an option to link your Pro Xtra and Buildertrend accounts to enable you to:")),
        firstInfoList(),
        React.createElement("div", { className: "sui-pb-1" },
            React.createElement(Typography, { variant: "body-base" },
                "By clicking \u201CConnect\u201D you: (i) represent that you have a valid account with Buildertrend; (ii) acknowledge that your use of the Buildertrend platform is governed by Buildertrend's",
                ' ',
                builderTrendTermsAndConditions(),
                " and",
                ' ',
                builderTrendPrivacyStatementLink(),
                "; and (iii) agree that The Home Depot will share the following information with Buildertrend (and that this information will be governed by Buildertrend's",
                ' ',
                builderTrendPrivacyStatementLink(),
                "):")),
        secondInfoList(),
        React.createElement(Typography, { variant: "body-xs" },
            React.createElement("strong", null, "*"),
            " Excludes special orders, may not be combined with other offers or pricing terms, discount applied before taxes and delivery charges.")));
};
/**
 * Buildertrend Elements for Successful and Failed linking
 */
var successfulLinkingBodyElement = function () {
    return (React.createElement("div", { className: "sui-flex" },
        React.createElement("div", { className: "sui-w-11" },
            React.createElement(Checkmark, { color: "success" })),
        React.createElement("div", null,
            React.createElement("div", { className: "sui-text-[#2596be] sui-font-bold" },
                React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Your Buildertrend account is now linked.")),
            React.createElement("div", { className: "sui-pt-2" },
                React.createElement(Typography, null, "Please allow 24-48 hours depending on the size of your account history to display in your Buildertrend account.")))));
};
var failedLinkingBodyElement = function (errCode) {
    var btLinkErrorMessage = integrationMessageHelper[errCode]
        ? integrationLinkErrorMessageHelper[errCode]
        : integrationLinkErrorMessageHelper.DEFAULT;
    return (React.createElement("div", { className: "sui-flex" },
        React.createElement("div", { className: "sui-w-16" },
            React.createElement(ErrorFilled, { color: "danger" })),
        React.createElement("div", null,
            React.createElement("div", { className: "sui-text-danger sui-font-bold " },
                React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Unable to Connect Accounts")),
            React.createElement("div", { className: "sui-pt-2" },
                React.createElement(Typography, null, btLinkErrorMessage)))));
};
var LinkingBodyElement = function (props) {
    var _a, _b, _c, _d, _e;
    var btApiState = props.btApiState;
    if (btApiState.isLoading) {
        return React.createElement(React.Fragment, null, "Loading here...");
    }
    if ((_a = btApiState === null || btApiState === void 0 ? void 0 : btApiState.btResponse) === null || _a === void 0 ? void 0 : _a.errors) {
        return failedLinkingBodyElement((_d = (_c = (_b = btApiState === null || btApiState === void 0 ? void 0 : btApiState.btResponse) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.errorCode);
    }
    if ((_e = btApiState === null || btApiState === void 0 ? void 0 : btApiState.btResponse) === null || _e === void 0 ? void 0 : _e.linked) {
        return successfulLinkingBodyElement();
    }
    return (React.createElement(React.Fragment, null,
        builderTrendAuthorizeShare(),
        buildertrendInfo()));
};
/**
 * Buildertrend Body element and components for disconnecting Buildertrend Account
 */
var adminUnlinkRadioElement = function (props) { return (React.createElement("div", { className: "sui-pt-2" },
    React.createElement(RadioGroup, { orientation: "vertical", "aria-labelledby": "demo-controlled-radio-buttons-group", name: "controlled-radio-buttons-group", value: props.adminUnlinkRadio, onChange: function (event) {
            props.setAdminUnlinkRadio(event.target.value);
        } },
        React.createElement(SelectionControlLabel, { value: "customer", label: "Company Account" },
            React.createElement(Radio, null)),
        React.createElement("p", { style: { padding: '0px 0px 20px 32px' } }, "This will disconnect The Home Depot from Buildertrend and you will no longer be able to sync information from past purchases and saved products."),
        React.createElement(SelectionControlLabel, { value: "user", label: "User Account Only" },
            React.createElement(Radio, null)),
        React.createElement("p", { style: { paddingLeft: '32px' } }, "You will no longer be able to send items to Buildertrend. Other users on this account will still be able to sync with Buildertrend however.")))); };
var adminUnlink = function (props) { return (React.createElement("div", null,
    React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Which account would you like to disconnect?"),
    adminUnlinkRadioElement(props))); };
var userUnlink = function () { return (React.createElement("div", null,
    React.createElement("p", { style: { padding: '25px 0px 30px 0px' } }, "You will no longer be able to send items to Buildertrend. Other users on this account will still be able to sync with Buildertrend however."))); };
/**
 * Successful UI for Disconnect
 */
var successfulUnlinkBodyElement = function () {
    return (React.createElement("div", { className: "sui-flex" },
        React.createElement("div", { className: "sui-w-11" },
            React.createElement(Checkmark, { color: "success" })),
        React.createElement("div", { className: "sui-text-[#00873C] sui-font-bold" },
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Your Buildertrend account has been disconnected."))));
};
/**
 * Failed UI for Disconnect
 */
var failedUnlinkingBodyElement = function () {
    return (React.createElement("div", { className: "sui-flex" },
        React.createElement("div", { className: "sui-w-16" },
            React.createElement(ErrorFilled, { color: "danger" })),
        React.createElement("div", null,
            React.createElement("div", { className: "sui-text-danger sui-font-bold sui-px-1" },
                React.createElement(Typography, { variant: "body-base", weight: "bold" }, "Unable to Disconnect Accounts")),
            React.createElement("div", { className: "sui-pt-2" },
                React.createElement(Typography, null,
                    ' ',
                    "We were unable to disconnect your account from Buildertrend. Please close this window and retry by clicking the Disconnect Buildertrend link again, or contact Customer Support if you continue to receive this error.")))));
};
/**
 *
 * @param props
 * @returns
 *
 * Handles the rendering of the Unlink default UI, along with the linking and
 * unlinking api UI changes.
 */
var UnlinkingBodyElement = function (props) {
    var _a;
    var role = props.role, adminUnlinkRadio = props.adminUnlinkRadio, setAdminUnlinkRadio = props.setAdminUnlinkRadio, btApiState = props.btApiState;
    if (btApiState.isLoading) {
        return React.createElement(React.Fragment, null, "Loading here...");
    }
    if ((_a = btApiState === null || btApiState === void 0 ? void 0 : btApiState.btResponse) === null || _a === void 0 ? void 0 : _a.errors) {
        return failedUnlinkingBodyElement();
    }
    if (btApiState === null || btApiState === void 0 ? void 0 : btApiState.btResponse) {
        return successfulUnlinkBodyElement();
    }
    return (React.createElement("div", null,
        React.createElement("div", { className: "builder-trend-response" }, role === 'ADMIN'
            ? adminUnlink({ adminUnlinkRadio: adminUnlinkRadio, setAdminUnlinkRadio: setAdminUnlinkRadio })
            : userUnlink())));
};
/**
 * Function that handles the Buildertrend modal body for Connecting and Disconnecting
 */
export var BuildertrendModalBody = function (props) {
    var userIsLinked = props.userIsLinked, adminUnlinkRadio = props.adminUnlinkRadio, setAdminUnlinkRadio = props.setAdminUnlinkRadio, btApiState = props.btApiState;
    var UnlinkingElementProps = {
        role: 'ADMIN',
        adminUnlinkRadio: adminUnlinkRadio,
        setAdminUnlinkRadio: setAdminUnlinkRadio,
        btApiState: btApiState,
    };
    var LinkingElementProps = {
        btApiState: btApiState,
    };
    if (userIsLinked) {
        return (React.createElement(React.Fragment, null,
            React.createElement(UnlinkingBodyElement, __assign({}, UnlinkingElementProps))));
    }
    return React.createElement(LinkingBodyElement, __assign({}, LinkingElementProps));
};
